<template>
  <div id="BookCoach" class="book-coach">
    <template v-if="isGetCoachLoading">
      <b-spinner class="brand-primary"></b-spinner>
    </template>
    <template v-else-if="selectedCoachEvents && selectedCoachEvents.length">
      <h4 class="select-coach-subtitle brand-text">
        What date suits you best to chat?
      </h4>
      <div
        class="animate__animated animate__fadeIn"
      >
        <div class="slick-container">
          <slick ref="slickRef" class="slick-class" :options="slickOptions">
            <b-button
              v-for="(event, key) in selectedCoachEvents"
              :key="key"
              :variant="
                event.date === selectedDate ? 'option-selected' : 'option'
              "
              class="btn-date-time fixed-width mr-3 ml-1"
              @click="selectDate(event.date)"
            >
              {{ getFormatedDate(event.date, "DD MMM YYYY") }}
            </b-button>
          </slick>
        </div>
      </div>
    </template>
    <div v-if="selectedDate" class="select-coach-dates">
      <h4 class="select-coach-subtitle brand-text">
        Choose Time
      </h4>
      <div v-if="timeSlots" class="dmh-timeslots-container">
        <div
          class="dmh-timeslot-item"
          v-for="(timeslot, i) in timeSlots"
          :key="i"
          @click="selectTimeslot(timeslot)"
        >
          <b-button
            :variant="
              timeslot.id === selectedTimeslotId ? 'option-selected' : 'option'
            "
            class="btn-date-time"
          >
            {{ timeslot.start.split(" ")[1].slice(0, 5) }}
          </b-button>
        </div>
      </div>
    </div>
    <p
      class="select-coach-text mb-3 brand-text"
      v-if="selectedDate && selectedTimeslot"
    >
      You have selected
      <span class="bold-text">{{
        getFormatedDate(selectedDate, "DD/MM/YYYY")
      }}</span>
      at
      <span class="bold-text">{{
        getHoursMinutes(selectedTimeslot.start, true)
      }}</span>
      with
      <span class="bold-text">{{ selectedCoachData.name }}</span>
    </p>
    <p class="select-coach-text mb-3 brand-text">
      By booking an appointment, you agree to the following
      <a target="_blank" href="/terms-and-conditions/self-pay">terms & conditions</a>.
    </p>
    <p class="select-coach-text mb-3 brand-text">What happens next?</p>
    <ol class="select-coach-text pl-4 brand-text">
      <li>
        You'll receive a confirmation email with details of your booking and how to join your appointment.
      </li>
      <li>
        To join your appointments kindly return to the App or web portal.
      </li>
      <li>
        Navigate to “My Health” then click the “calendar” icon in the top right corner of the screen to access your bookings.
      </li>
      <li>
        Please join your appointment a few minutes early, to make sure everything is working correctly.
      </li>
    </ol>
    <p class="select-coach-text mb-5 brand-text">
      If you have any issues or questions, please use the chat option available within your personal coaching area to speak to your coach.
    </p>
    <div
      class="d-flex justify-content-end align-self-end pt-5 dmh-btn-container"
    >
      <b-button
        @click="handlePreviousBtnClick"
        variant="cta-outline"
        size="lg"
        class="py-4 px-4"
        squared
        >Previous
      </b-button>
      <b-button
        variant="cta"
        size="lg"
        :disabled="!selectedTimeslotId"
        @click="createAppointmentStripe"
      >
        <span v-if="!isConfirmingAppointment">Book Now</span>
        <b-spinner v-else></b-spinner>
      </b-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
import { mapState } from "vuex";
import ErrorModal from "../GP/ErrorModal.vue";
import slick from "vue-slick";

export default {
  name: "BookCoach",
  components: {
    slick
  },
  props: {
    coachId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      timeSlots: [],
      isGetCoachLoading: false,
      isConfirmingAppointment: false,
      selectedCoachData: null,
      selectedCoachEvents: null,
      selectedDate: null,
      selectedTimeslotId: null,
      selectedTimeslot: null,
      slickOptions: {
        infinite: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></button>`,
        prevArrow: `<button type="button" class="slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></button>`,
        slidesToScroll: 4,
        slidesToShow: 4,
        responsive: [
        {
            breakpoint: 700,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getCoach(this.coachId);
  },
  computed: {
    ...mapState(["handoverPage"])
  },
  methods: {
    async getCoach(coachId) {
      if (this.isGetCoachLoading) return;
      try {
        this.isGetCoachLoading = true;
        const payload = {
          user_id: this.$store.getters.user_id,
          coach_id: coachId
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/coach/get-coach",
          payload,
          config.options
        );
        if (res.data.success) {
          this.selectedCoachData = res.data.coach;
          this.selectedCoachEvents = res.data.events;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isGetCoachLoading = false;
      }
    },
    async createAppointmentStripe() {
      if (this.isConfirmingAppointment) return;
      try {
        this.isConfirmingAppointment = true;
	      let s_type = this.handoverPage?.service_type ?? this.$route.query.service_id ?? 'no_service';
        const payload = {
          user_id: this.$store.getters.user_id,
          clinician_id: null,
          start_date: this.selectedDate,
          start_time: this.selectedTimeslot.start.split(" ")[1].slice(0, 5),
          slot_id: `${this.selectedTimeslotId}`,
          service_type: s_type,
          gender_preference: null,
          tags: null,
          platform: "web"
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/get-payment-link",
          payload,
          config.options
        );
        if (res.data.success) {
          window.location.replace(res.data.link);
        } else {
          if (res.data.msg) {
            this.openErrorModal(res.data.msg, "Please try again");
          } else {
            this.openErrorModal(
              "Sorry, something went wrong",
              "Please try again later"
            );
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isConfirmingAppointment = false;
      }
    },
    openErrorModal(title, error, redirect, goBack) {
      const content = this.$createElement(ErrorModal, {
        props: { title, error, redirect, goBack }
      });
      const skin = this.$store.getters.skin;
      let opts = {
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: "error-modal"
      };
      return this.$bvModal.msgBoxOk(content, opts);
    },
    selectDate(date) {
      this.selectedDate = date;
      this.selectedTimeslot = null;
      this.selectedTimeslotId = null;
      const selectedEvent = this.selectedCoachEvents.find(event => {
        return event.date === date;
      });
      this.timeSlots = selectedEvent.slots;
    },
    selectTimeslot(timeslot) {
      this.selectedTimeslotId = timeslot.id;
      this.selectedTimeslot = timeslot;
    },
    handlePreviousBtnClick() {
      this.$emit("previous");
    }
  }
};
</script>

<style lang="less">

#BookCoach {
  &.book-coach {
    max-width: 650px;
    margin: 0 auto;
  
    .select-coach-subtitle {
      color: #3a4a61;
      margin: 0 auto;
      text-align: left;
      font-size: 1.8rem;
      letter-spacing: 0;
      font-family: "PlusJakartaSansBold";
      margin-bottom: 20px;
    }
    .select-coach-dates {
      margin: 0 auto;
    }
  
    .select-coach-text {
      font-size: 1.6rem;
      line-height: 2rem;
    }
  
    .bold-text {
      font-family: "PlusJakartaSansBold";
    }
    .dmh-btn-container {
      gap: 24px;
    }
  }

  .dmh-timeslots-container {
    display: grid;
    gap: 8px 12px;
    grid-template-columns: auto auto auto;
    margin-bottom: 32px;
  }
  
  .btn-date-time {
    width: 100%;
  }
  
  .slick-container {
    width: 100%;
    max-width: 616px;
    margin-bottom: 32px;
  }

  .slick-track {
    margin-left: 0;
  }
  
  .slick-slider {
    position: relative;
  }
  
  .slick-next, .slick-prev {
    position: absolute;
    z-index: 10;
    top: 50%;
    background-color: transparent;
    border: none;
    padding: 0 6px;
    transform: translateY(-50%);
  
    .fa {
      font-size: 3rem;
      color: #1E1E22;
    }
  }
  
  .slick-next {
    right: -30px;
  }
  
  .slick-prev {
    left: -30px;
  }
  
  .slick-slide {
    margin: 0 6px;
  }
  
  .slick-disabled {
    display: none !important;
  }
  
  @media only screen and (max-width: 700px) {
    .slick-next {
      right: -20px;
    }
  
    .slick-prev {
      left: -20px;
    }
  }
}

</style>
